import React from "react";
import { PawPrint } from "lucide-react";

export const Logo = ({ className = "", compact = false }) => {
  return (
    <a
      href="/"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2 ${className}`}
    >
      <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#172554] text-white shadow-sm">
        <PawPrint className="h-5 w-5" />
        <span className="absolute -bottom-0.5 -right-0.5 h-2 w-2 rounded-full bg-[#EA580C] ring-2 ring-white" />
      </span>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-display text-lg font-semibold tracking-tight text-slate-900">
            CEQ<span className="text-[#1E3A8A]">Vet</span>
          </span>
          <span className="mt-0.5 text-[10px] uppercase tracking-[0.18em] text-slate-500">
            Centro Quirúrgico Vet.
          </span>
        </span>
      )}
    </a>
  );
};

export default Logo;
